import { Theme } from "./theme";

export const isDarkTheme = ({
	theme,
	prefersDark,
}: {
	theme: Theme;
	prefersDark: boolean;
}) => (theme === Theme.system ? prefersDark : theme === Theme.dark);
